import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import DiscountsPopup from '../DiscountsPopup';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import s from './DiscountsPopupTrigger.scss';
const DiscountsPopupTrigger = ({ className, discounts, icon })=>{
    const [showDicountsPopup, setShowDiscountsPopup] = useState(false);
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], className)
    }, /*#__PURE__*/ React.createElement(TextButton, {
        key: "save",
        size: "medium",
        variant: "main",
        priority: "secondary",
        className: s['btn-show-discounts'],
        onClick: ()=>setShowDiscountsPopup(true),
        icon: icon,
        iconClassName: s['icon-discount']
    }, t('popup.discounts.trigger.viewAll')), /*#__PURE__*/ React.createElement(DiscountsPopup, {
        isOpen: showDicountsPopup,
        onRequestClose: ()=>setShowDiscountsPopup(false),
        discounts: discounts
    }));
};
DiscountsPopupTrigger.displayName = 'DiscountsPopupTrigger';
export default DiscountsPopupTrigger;

//# sourceMappingURL=DiscountsPopupTrigger.js.map